export const title = ({ theme: { colors } }) => ({
    lineHeight: 1.31,
    letterSpacing: '0.3px',
    color: colors.text,
    fontSize: '1rem',
    padding: '23px 30px 20px',
});
